import axios from 'axios'

import config from '../../config.client.js'
import queryString from 'query-string'

const url = config.apiUrl

export default {
  getWopi: uuid => {
    return axios.get(url + `wopi/${uuid}`)
  },

  getTranslationsForWopiQuestions: language => {
    return axios.get(url + `translations/${language}/wopi`)
  },

  savePersonalInformation: (uuid, givenName, familyName, age, sex) =>
    axios.post(url + `wopi/${uuid}/information`, {
      givenName: givenName,
      familyName: familyName,
      age: age ? parseInt(age) : null,
      sex: sex
    }),

  startWopi: uuid => {
    return axios.patch(url + `wopi/${uuid}/start`, {})
  },

  answerWopiQuestion: (uuid, answers, activeQuestionIndex) =>
    axios.patch(url + `wopi/${uuid}/answers`, {
      answers: answers,
      activeQuestionIndex: activeQuestionIndex
    }),

  invite: (organisationId, recipients, title, message, signature, organisation, role, language) =>
    axios.post(url + `organisations/${organisationId}/invitations`, {
      recipients: recipients,
      title: title,
      message: message,
      signature: signature,
      language: language,
      organisation: organisation,
      role: role
    }),

  generateNoEmailInvitations: (organisationId, recipientCount, organisation, role, language) =>
    axios.post(url + `organisations/${organisationId}/invitations/no-email`, {
      recipientCount: parseInt(recipientCount, 10),
      language: language,
      organisation: organisation,
      role: role
    }),

  search: (organisationId, keyword, filters, page, showOnlyOwn) => {
    const filterQuery = {
      keyword: keyword,
      page: page
    }

    if (showOnlyOwn) {
      filterQuery['own'] = 1
    }

    if (filters.status === 'open') {
      filterQuery['status'] = 'open'
    }

    return axios.get(
      url + `organisations/${organisationId}/wopi?${queryString.stringify(filterQuery)}`
    )
  },

  delete: (organisationId, uuid) =>
    axios.delete(url + `organisations/${organisationId}/wopi/${uuid}`)
}



// WEBPACK FOOTER //
// ./src/services/wopi.js